module.exports = __webpack_public_path__ + "img/tasks_grey.da9f82f9.png";